var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AddAudience',{ref:"add-audience",attrs:{"from":"page"},on:{"save":_vm.refreshAduience,"close":_vm.back}})}
var staticRenderFns = []

export { render, staticRenderFns }